var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-container" }, [
    _c(
      "table",
      [
        _c("thead", { staticClass: "tablehead" }, [
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$t("DeviceID")))]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.$t("DeviceOS")))]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.$t("CreationTime")))]),
            _vm._v(" "),
            _c("th", [_vm._v(_vm._s(_vm.$t("ExpirationTime")))])
          ])
        ]),
        _vm._v(" "),
        _vm._l(_vm.result, function(items, key) {
          return _c(
            "tbody",
            [
              _vm._l(items, function(item) {
                return _c("tr", { key: item.deviceId }, [
                  _c("td", [_vm._v(_vm._s(item.deviceId))]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(item.os) +
                        " " +
                        _vm._s(item.version) +
                        " " +
                        _vm._s(item.platform)
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(_vm._f("moment")(item.created, "ddd, MMM Do YYYY"))
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("moment")(item.trusted, "ddd, MMM Do YYYY")
                        )
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "delete",
                          on: {
                            click: function($event) {
                              return _vm.deleteDevice(key, item.deviceId)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("DeleteTrustedDevice")))]
                      )
                    ],
                    1
                  )
                ])
              }),
              _vm._v(" "),
              _vm.hasTrustedDevices
                ? _c("tr", [
                    _c(
                      "td",
                      { attrs: { colspan: "4" } },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "deleteAllDevices",
                            on: {
                              click: function($event) {
                                return _vm.untrustAllDevices(key)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("DeleteAllTrustedDevices")))]
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.hasTrustedDevices
                ? _c("tr", [
                    _c("td", { attrs: { colspan: "6" } }, [
                      _vm._v(_vm._s(_vm.$t("No.Trusted.Devices")))
                    ])
                  ])
                : _vm._e()
            ],
            2
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00b7e5a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00b7e5a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/IntegratedWallet/MyDevices.vue
// module id = null
// module chunks = 